import React from 'react';

const CustomWaitingRoom = ({ userName = 'Guest', roomName = 'Meeting Room', onBack }) => {
    return (
        <div style={{
            width: '100vw',
            height: '100vh',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
            color: '#ffffff',
            position: 'fixed',
            top: 0,
            left: 0,
            zIndex: 10000
        }}>
            {/* Main Content */}
            <div style={{
                textAlign: 'center',
                maxWidth: '600px',
                padding: '40px',
                background: 'rgba(255, 255, 255, 0.1)',
                borderRadius: '20px',
                backdropFilter: 'blur(10px)',
                boxShadow: '0 8px 32px 0 rgba(31, 38, 135, 0.37)'
            }}>
                {/* Loading Spinner */}
                <div style={{
                    width: '80px',
                    height: '80px',
                    margin: '0 auto 30px',
                    border: '4px solid rgba(255, 255, 255, 0.3)',
                    borderTop: '4px solid #ffffff',
                    borderRadius: '50%',
                    animation: 'spin 1s linear infinite'
                }}></div>

                {/* Title */}
                <h1 style={{
                    fontSize: '32px',
                    fontWeight: '600',
                    margin: '0 0 20px 0',
                    letterSpacing: '-0.5px'
                }}>
                    Waiting for the host...
                </h1>

                {/* Description */}
                <p style={{
                    fontSize: '18px',
                    margin: '0 0 30px 0',
                    opacity: '0.9',
                    lineHeight: '1.6'
                }}>
                    The meeting will start once the host joins.
                    <br />
                    Please wait, you'll be admitted shortly.
                </p>

                {/* User Info */}
                <div style={{
                    background: 'rgba(255, 255, 255, 0.15)',
                    padding: '20px',
                    borderRadius: '12px',
                    marginTop: '20px'
                }}>
                    <p style={{
                        margin: '0 0 8px 0',
                        fontSize: '14px',
                        opacity: '0.8',
                        textTransform: 'uppercase',
                        letterSpacing: '1px',
                        fontWeight: '500'
                    }}>
                        Joining as
                    </p>
                    <p style={{
                        margin: '0',
                        fontSize: '20px',
                        fontWeight: '600'
                    }}>
                        {userName}
                    </p>
                </div>

                {/* Back Button */}
                {onBack && (
                    <button
                        onClick={onBack}
                        style={{
                            marginTop: '30px',
                            padding: '15px 40px',
                            background: 'rgba(255, 255, 255, 0.2)',
                            border: '2px solid rgba(255, 255, 255, 0.3)',
                            borderRadius: '12px',
                            color: 'white',
                            fontSize: '16px',
                            fontWeight: '600',
                            cursor: 'pointer',
                            transition: 'all 0.3s ease',
                            backdropFilter: 'blur(10px)',
                            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: '10px',
                            width: '100%',
                            maxWidth: '200px',
                            margin: '30px auto 0'
                        }}
                        onMouseEnter={(e) => {
                            e.currentTarget.style.background = 'rgba(255, 255, 255, 0.3)';
                            e.currentTarget.style.transform = 'translateY(-2px)';
                            e.currentTarget.style.boxShadow = '0 6px 16px rgba(0, 0, 0, 0.2)';
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.background = 'rgba(255, 255, 255, 0.2)';
                            e.currentTarget.style.transform = 'translateY(0)';
                            e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.15)';
                        }}
                    >
                        <svg
                            width="20"
                            height="20"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="white"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        >
                            <path d="M19 12H5M12 19l-7-7 7-7"/>
                        </svg>
                        Go Back
                    </button>
                )}

                {/* Room Name */}
                {/* {roomName && (
                    <div style={{
                        marginTop: '20px',
                        padding: '15px',
                        background: 'rgba(255, 255, 255, 0.1)',
                        borderRadius: '8px'
                    }}>
                        <p style={{
                            margin: '0',
                            fontSize: '14px',
                            opacity: '0.8'
                        }}>
                            Meeting: <strong>{roomName}</strong>
                        </p>
                    </div>
                )} */}
                {/* <></> */}
            </div>

            {/* CSS Animation */}
            <style>{`
                @keyframes spin {
                    0% { transform: rotate(0deg); }
                    100% { transform: rotate(360deg); }
                }
            `}</style>
        </div>
    );
};

export default CustomWaitingRoom;
